// StepsView.tsx
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from '../shared/header';
import Button from '../shared/button';
import { useGlobalState } from '../../providers/globalState/GlobalStateProvider';
import ScrollToTop from '../shared/scrollToTop';
import { CREATING_PROGRAM_VERSION } from '../../providers/setting';
import Loader from '../shared/loader';

// Lazy-loaded step components
const Language = lazy(() => import('./language'));
const NameFilling = lazy(() => import('./nameFilling'));
const TopicsOfInterest = lazy(() => import('./topicsOfInterest'));
const PersonalPlan = lazy(() => import('./personalPlan'));
const InGoodHands = lazy(() => import('./inGoodHands'));
const GoalPractice = lazy(() => import('./goalPractice'));
const AskAboutTest = lazy(() => import('./askAboutTest'));
const VocabularyTest = lazy(() => import('./vocabularyTest'));
const GrammarTest = lazy(() => import('./grammarTest'));
const LexTest = lazy(() => import('./lexTest'));
const LexTestResults = lazy(() => import('./lexTestResults'));
const TestResults = lazy(() => import('./testResults'));
const BuildLearningPlan = lazy(() => import('./buildLearningPlan'));
const CreatingProgram = lazy(() => import('./creatingProgram'));
const CreatingProgramV2 = lazy(() => import('./creatingProgramV2'));
const Email = lazy(() => import('./emailView'));
const ExpectView = lazy(() => import('./expectView'));
const SingleChoiceView = lazy(() => import('../shared/singleChoiceView').then(m => ({ default: m.SingleChoiceView })));
const StruggleView = lazy(() => import('./struggleView'));
const StrugglesView = lazy(() => import('./struggles'));
const GenderSelection = lazy(() => import('./genderSelection'));
const Age = lazy(() => import('./age'));
const Summary = lazy(() => import('./summary'));
const AgeV2 = lazy(() => import('./ageV2'));
const HowMultiView = lazy(() => import('./howMulti'));
const LearningEfficiency = lazy(() => import('./learningEfficiency'));
const LevelUp = lazy(() => import('./levelUp'));
const StartStep = lazy(() => import('./startStep'));

// Heavy payment components - loaded separately
const ChoosePlaneWithPayment = lazy(() =>
    import('../../providers/paymentProvider/PaymentProviderFactory').then(({ PaymentProviderFactory }) =>
        import('./choosePlane').then(({ default: ChoosePlane }) => ({
            default: () => (
                <PaymentProviderFactory>
                    <ChoosePlane />
                </PaymentProviderFactory>
            )
        }))
    )
);




function StepsView() {
    const { isDarkView, currentStep } = useGlobalState();

    return (
        <div className={isDarkView ? "App app-dark" : `App ${currentStep === "choosePlan" ? "paywall" : ""}`}>
            <Header />
            <ScrollToTop />
            <Suspense fallback={<Loader />}>
                <Routes>
                    <Route path="/" element={<Navigate to={`/start`} />} />
                    <Route path="/start" element={ <StartStep />} />
                    <Route path="/gender" element={<GenderSelection />} />
                    <Route path="/age" element={<Age />} />
                    <Route path="/language" element={<Language />} />
                    {/* <Route path="/video" element={<VideoStep />} /> */}
                    <Route path="/video" element={<Navigate to="/name" />} />
                    <Route path="/name" element={<NameFilling />} />
                    <Route path="/personalPlan" element={<PersonalPlan />} />
                    <Route path="/why" element={<SingleChoiceView type="whys" />} />
                    <Route path="/how" element={<HowMultiView />} />
                    <Route path="/learningEfficiencyFocus" element={<LearningEfficiency type='focus'/>} />
                    <Route path="/level" element={<SingleChoiceView type="levels" />} />
                    <Route path="/struggles" element={<StrugglesView />} />
                    <Route path="/struggleView/:id" element={<StruggleView />} />
                    <Route path="/learningEfficiencyRegularStudy" element={<LearningEfficiency type='regularStudy'/>} />
                    <Route path="/topics" element={<TopicsOfInterest />} />
                    <Route path="/goal" element={<GoalPractice />} />
                    <Route path="/askTest" element={<AskAboutTest />} />
                    <Route path="/vocabularyTestBegginer" element={<VocabularyTest />} />
                    <Route path="/vocabularyTestIntermediate" element={<VocabularyTest />} />
                    <Route path="/vocabularyTestAdvanced" element={<VocabularyTest />} />
                    <Route path="/grammarTest/:questionIndex" element={<GrammarTest />} />
                    <Route path="/testResults" element={<TestResults />} />
                    <Route path="/grammarTestResults" element={<TestResults />} />
                    <Route path="/lexTest/:questionIndex" element={<LexTest />} />
                    <Route path="/lexTestResults" element={<LexTestResults />} />
                    <Route path="/planBuild" element={<BuildLearningPlan />} />
                    <Route path="/creatProgram" element={CREATING_PROGRAM_VERSION === 'v2' ? <CreatingProgramV2 /> : <CreatingProgram />} />
                    <Route path="/email" element={<Email />} />
                    <Route path="/expect1Week" element={<ExpectView />} />
                    <Route path="/expect4Week" element={<ExpectView />} />
                    <Route path="/expect12Week" element={<ExpectView />} />
                    <Route path="/expectMonth12" element={<ExpectView />} />
                    <Route path="/goodHands1" element={<InGoodHands />} />
                    <Route path="/goodHands2" element={<InGoodHands />} />
                    <Route path="/summary" element={<Summary/>} />
                    <Route path="/levelUp" element={<LevelUp/>} />
                    {/* <Route path="/levelUp" element={<Navigate to="/choosePlan" />} /> */}
                    <Route path="/choosePlan" element={<ChoosePlaneWithPayment />} />
                </Routes>
            </Suspense>
            <Button />
            {/* <Cookies/> */}
        </div>
    );
}

export default StepsView;